<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
      <el-breadcrumb-item>Optimization</el-breadcrumb-item>
      <el-breadcrumb-item>SA</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="content">Synthetic Accessibility (SA) estimates the ease of chemical synthesis of a molecule based on fragment contributions and structural complexity. It is widely used to evaluate the practicality of drug-like compound design. The SA Optimization module performs fragment-level molecular refinement within the AIDrugDesigner platform. Users submit a SMILES string of a molecule for optimization, and the model identifies potential modification sites and applies single-fragment substitutions while preserving the core scaffold, enabling controlled structural optimization toward improved synthetic accessibility. Optimized molecules are returned as SMILES strings together with recalculated SA scores, physicochemical properties, and visualization results.</p>
    <el-form :label-position="labelPosition" label-width="180px" :model="formInfo" ref="formInfo" :rules="rules"
             style="text-align: left;"
             v-loading="loading"
             class="content"
             element-loading-text="The input data is being submitted, please wait……">
      <el-form-item   prop="radio" label="1. Upload SMILES.txt or input SMILES for your optimization.">
        <el-radio v-model="formInfo.radio" label="1">
          Enter a list of SMILES.
          <el-input type="textarea" autosize v-model="formInfo.SMILES" placeholder="SMILES" style="width: 500px; margin-left: 85px"></el-input>
        </el-radio>
        <br><br>
        <el-radio v-model="formInfo.radio" label="2">
          Select a module file.
          <div style="display: inline-block; vertical-align: middle; margin-left: 100px">
            <el-upload
                class="upload-demo"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                action=""
                :http-request="httpRequest"
                :before-remove="beforeRemove"
                :multiple="false"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="formInfo.fileList">
              <el-button type="primary">Click to upload</el-button>
              <el-button round type="success" plain @click="show()">Show example.txt</el-button>
            </el-upload>
          </div>
        </el-radio>

      </el-form-item>
<!--      <el-form-item prop="radio2" label="2. Select the type of optimization method(optional)">-->
<!--        <el-row :gutter="20">-->
<!--          <el-col :span="11">-->
<!--            <el-radio v-model="formInfo.radio2" label="1">-->
<!--              <el-select v-model="formInfo.optMethod1" placeholder="请选择" :disabled="formInfo.radio2 != '1'">-->
<!--                <el-option-->
<!--                    v-for="item in options1"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-radio>-->
<!--          </el-col>-->
<!--          <el-col :span="2" class="line">-->
<!--            <el-divider direction="vertical"></el-divider>-->
<!--          </el-col>-->
<!--          <el-col :span="11">-->
<!--            <el-radio v-model="formInfo.radio2" label="2">-->
<!--              <el-select v-model="formInfo.optMethod2" placeholder="请选择" :disabled="formInfo.radio2 != '2'">-->
<!--                <el-option-->
<!--                    v-for="item in options2"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--              <span style="display: inline-block; margin: 0 20px 0; font-size: 16px;">similarity(optional)</span>-->
<!--              <el-input v-model="formInfo.similarity" placeholder="请输入内容" style="width: 100px;"></el-input>-->
<!--            </el-radio>-->
<!--          </el-col>-->
<!--        </el-row>-->


<!--      </el-form-item>-->
      <el-form-item prop="num" label="2. Enter the number of molecules you want to generate (optional, max=100).">
        <el-input v-model.number="formInfo.num"></el-input>
      </el-form-item>
      <el-form-item prop="email"
                    label="3. Please leave your email address and we will send the generated results to your email.">
        <el-input v-model="formInfo.email"></el-input>
        <span style="font-size: 12px; color: #909399; line-height: 1.5; display: block; margin-top: 4px;">
          Your uploaded data are used only for this task and are not shared or used for any other purpose. They are temporarily stored on our private server for up to six months.
        </span>
      </el-form-item>
      <el-form-item class="submit">
        <el-button type="primary" @click="submitForm">Submit</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
  import OCL from "openchemlib";
  var sid=""
  export default {
  name: "SA",
  data() {
    return {
      loading:false,
      labelPosition: 'top',
      rules: {
        email: [
          { message: 'Please input the email address.', trigger: 'blur'},
          {type: 'email', message: 'Please input the correct email address', trigger: ['blur', 'change']}
        ],
        num: [
          // {required: true, message: 'The number of molecules cannot be empty'},
          {type: 'number', min:0,max:100,message: 'The number of molecules should be numerical.Range: 0~100.'}
        ],
        radio: [
          {required: true, message: 'Please choose one of them.'}
        ],
        radio2: [
          {required: true, message: 'Please choose one of them.'}
        ]
      },
      formInfo: {
        radio: '1',
        radio2: '1',
        SMILES: 'Nc1ncnc2c1ncn2C1OC(CSCCC(O)CO)C(O)C1O',
        fileList: [],
        optMethod1: 'Modof',
        optMethod2: 'method1',
        num: 20,
        email: '',
        similarity: 0.6
      },
      options1: [
        {
          value: 'Modef',
          label: 'Modef'
        },
        {
          value: 'method2',
          label: 'method2'
        }
      ],
      options2: [
        {
          value: 'method1',
          label: 'method1',
        },
        {
          value: 'method2',
          label: 'method2'
        }
      ]
    };
  },
  methods: {
    show(){
      window.open("SMILES.txt")
    },
    handleRemove(file, fileList) {
      this.formInfo.fileList.pop();
      console.log(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The current limit is 1 file selected`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`Confirmed to remove ${file.name}?`);
    },
    httpRequest(param) {
      console.log(param);
      console.log(param.file.name);

      const fileName = param.file.name;
      const suffix = ".txt";
      if (fileName.toLowerCase().endsWith(suffix.toLowerCase()))
      {
        this.formInfo.fileList.push(param.file);
      }
      else
      {

        this.formInfo.fileList.pop();
        // 弹出一个带有消息的警告框
        return this.$confirm(`Please upload a txt type file.`);
      }
    },
    checkSmiles(input)
    {
      const smiles = input;
      // 使用OCL解析SMILES序列
      try {
        const molecule = OCL.Molecule.fromSmiles(smiles);
        if (molecule === null) {
          return true
          // console.log('无效的SMILES序列');
        } else {
          console.log("SMILES"+molecule)
          return false
          // console.log('有效的SMILES序列');
        }
      } catch (error) {
        return true
        // console.log("eeeeeeeeeeeeeeeeee")
      }
    },
    submitForm() {

      const formData = new FormData();
      if (this.formInfo.radio === '1') {
        // 选择SMILES
        if (this.formInfo.SMILES === '') {
          this.$alert('Please input SMILES.');
          return;
        }
        //检查smiles序列
        if(this.checkSmiles(this.formInfo.SMILES))
        {
          console.log(this.formInfo.SMILES)

          this.$alert(this.formInfo.SMILES+" are illegal SMILES sequences, please re-enter!","Tips",{
            confirmButtonText: 'OK'
          })
          return;
        }
        formData.append("content", this.formInfo.SMILES);
        formData.append("file", new File([''], 'nofile.txt'))
      } else {
        // 选择上传文件
        if (this.formInfo.fileList.length == 0) {
          this.$alert('Please upload the file.');
          return;
        }
        formData.append("file", this.formInfo.fileList[0], this.formInfo.fileList[0].name);
      }
      this.$refs['formInfo'].validate((valid) => {
        if (valid) {
          this.loading=true

          sid = require('uuid').v1()//生成uuid
          console.log('submit');
          if (this.formInfo.radio2 == '1') {
            formData.append('optimizationMethod',this.formInfo.optMethod1);
          } else {
            formData.append('optimizationMethod', this.formInfo.optMethod2);
            formData.append('similarity', this.formInfo.similarity);
          }
          formData.append("num", this.formInfo.num);
          if(this.formInfo.email=='')
          {
            this.formInfo.email="2659381657@qq.com"
          }
          formData.append("email", this.formInfo.email);
          formData.append("uid", sid);
          // TODO: change the url
          axios.post("/optimization/SA", formData).then(res => {
            this.loading=false
            console.log(res.data);
            var that=this
            if(res.data.code === 200)
            {
              this.$router.push({
                path:'/generation/success',
                query:{
                  sid:sid
                }
              })
            }
          }).catch(err => {
            console.log(err);
            this.$alert('error submit!!');
            this.loading=false
            return false;
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1160px;
  margin: 0 auto;
}

p {
  line-height: 1.5em;
  text-align: left;
}

.submit {
  text-align: center;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
